export default __webpack_public_path__ + "static/media/desk_preland_1.997e9d94.jpg";